import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useUpdateProductClassMutation } from '../../../../graphql'

export default function useUpdateProductClassHandler( options?: any ) {
	const [ updateProductClass ] = useUpdateProductClassMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( productClassId: string, catClass?: string, categoryName?: string, classification?: string ) => {
		const result = await updateProductClass( { variables: {
			productClassId,
			catClass,
			categoryName,
			classification,
		} } )

		if ( result.data?.updateProductClass?.success ) {
			showSuccess( `updateInventoryLocationSuccess${Date.now()}`, result.data?.updateProductClass?.message ?? 'Successfully updated product class!' )
		} else {
			showError( `updateInventoryLocationError${Date.now()}`, result.data?.updateProductClass?.message ?? 'Sorry, an error occurred' )
		}
	}
}
